import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { LangProvider } from "@/contexts/LangContext";
import { Toaster } from "sonner";
import Nav from "@/components/Nav";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import Dashboard from "@/pages/Dashboard";
import Avatar from "@/pages/Avatar";
import Coach from "@/pages/Coach";
import Stats from "@/pages/Stats";
import Programs from "@/pages/Programs";
import Journal from "@/pages/Journal";
import Video from "@/pages/Video";
import Medical from "@/pages/Medical";
import Daily from "@/pages/Daily";
import Report from "@/pages/Report";
import Team from "@/pages/Team";
import Club from "@/pages/Club";
import ClubPlayer from "@/pages/ClubPlayer";
import ClubCompare from "@/pages/ClubCompare";
import Pricing from "@/pages/Pricing";
import Billing from "@/pages/Billing";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";
import PaywallListener from "@/components/PaywallListener";
import VerifyBanner from "@/components/VerifyBanner";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import VerifyEmail from "@/pages/VerifyEmail";

function App() {
  return (
    <div className="App min-h-screen">
      <LangProvider>
        <AuthProvider>
          <BrowserRouter>
            <Nav />
            <VerifyBanner />
            <PaywallListener />
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/auth" element={<Auth />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/verify-email" element={<VerifyEmail />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route path="/billing" element={<ProtectedRoute role={null} paywall={false}><Billing /></ProtectedRoute>} />
              <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
              <Route path="/avatar" element={<ProtectedRoute><Avatar /></ProtectedRoute>} />
              <Route path="/coach" element={<ProtectedRoute><Coach /></ProtectedRoute>} />
              <Route path="/stats" element={<ProtectedRoute><Stats /></ProtectedRoute>} />
              <Route path="/programs" element={<ProtectedRoute><Programs /></ProtectedRoute>} />
              <Route path="/journal" element={<ProtectedRoute><Journal /></ProtectedRoute>} />
              <Route path="/video" element={<ProtectedRoute><Video /></ProtectedRoute>} />
              <Route path="/medical" element={<ProtectedRoute><Medical /></ProtectedRoute>} />
              <Route path="/daily" element={<ProtectedRoute><Daily /></ProtectedRoute>} />
              <Route path="/report" element={<ProtectedRoute><Report /></ProtectedRoute>} />
              <Route path="/team" element={<ProtectedRoute paywall={false}><Team /></ProtectedRoute>} />
              <Route path="/club" element={<ProtectedRoute role="club"><Club /></ProtectedRoute>} />
              <Route path="/club/players/:id" element={<ProtectedRoute role="club"><ClubPlayer /></ProtectedRoute>} />
              <Route path="/club/compare" element={<ProtectedRoute role="club"><ClubCompare /></ProtectedRoute>} />
            </Routes>
            <Toaster theme="dark" position="top-right" />
          </BrowserRouter>
        </AuthProvider>
      </LangProvider>
    </div>
  );
}

export default App;
